<script setup lang="ts">
const { public: env } = useRuntimeConfig();

const imageUrl = computed(() => `url(${env.assetPrefix}/graphics/green-curtain-top.svg)`);
</script>

<template>
  <div class="curtain h-20 w-full bg-[--curtain]" />
</template>

<style scoped>
.curtain {
  -webkit-mask-image: v-bind(imageUrl);
  mask-image: v-bind(imageUrl);
  mask-repeat: repeat-x;
}
</style>
